import script from "./Asistent.vue?vue&type=script&setup=true&lang=js"
export * from "./Asistent.vue?vue&type=script&setup=true&lang=js"

import "./Asistent.vue?vue&type=style&index=0&id=889fdb50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-889fdb50"]])

export default __exports__